module.exports = __webpack_public_path__ + "static/media/organization.62216865.png";